// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.geographical-coverage-section {
  padding: 4rem 0;
  margin: 0 auto;
}
.geographical-coverage-section .geographical-coverage-wrap {
  width: 100%;
  max-width: var(--containerWidth);
  margin: 0 auto;
}
.geographical-coverage-section .geographical-coverage-wrap .geographical-coverage-box .img-box {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.geographical-coverage-section .geographical-coverage-wrap .geographical-coverage-box .img-box img {
  width: 100%;
  max-width: 100%;
  height: auto;
  filter: drop-shadow(0 0 0 var(--tertiaryMain-750));
  -webkit-filter: drop-shadow(0 0 0 var(--tertiaryMain-750));
}
@media screen and (max-width: 991.98px) {
  .geographical-coverage-section {
    padding: 2.5rem 0;
  }
}
@media screen and (max-width: 767.98px) {
  .geographical-coverage-section {
    padding: 2rem 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/GeographicalCoverageSection/GeographicalCoverageStyle.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,cAAA;AACF;AACE;EACE,WAAA;EACA,gCAAA;EACA,cAAA;AACJ;AAGM;EACE,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AADR;AAGQ;EACE,WAAA;EACA,eAAA;EACA,YAAA;EACA,kDAAA;EACA,0DAAA;AADV;AAOE;EA5BF;IA6BI,iBAAA;EAJF;AACF;AAWE;EArCF;IAsCI,eAAA;EARF;AACF","sourcesContent":[".geographical-coverage-section {\n  padding: 4rem 0;\n  margin: 0 auto;\n\n  .geographical-coverage-wrap {\n    width: 100%;\n    max-width: var(--containerWidth);\n    margin: 0 auto;\n\n    .geographical-coverage-box {\n\n      .img-box {    \n        width: 100%;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n\n        img {\n          width: 100%;\n          max-width: 100%;\n          height: auto;\n          filter: drop-shadow(0 0 0 var(--tertiaryMain-750));\n          -webkit-filter: drop-shadow(0 0 0 var(--tertiaryMain-750));\n        }\n      }\n    }\n  }\n\n  @media screen and (max-width: 991.98px) {\n    padding: 2.5rem 0;\n\n    .geographical-coverage-wrap {  \n      .geographical-coverage-box {\n      }\n    }\n  }\n\n  @media screen and (max-width: 767.98px) {\n    padding: 2rem 0;\n\n    .geographical-coverage-wrap {  \n      .geographical-coverage-box {\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
